import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { IAPIErrorObject } from '@shared/interfaces/api.interface';

export interface IRecycleBinLink {
  query?: string;
}

@Component({
    selector: 'app-form-errors',
    templateUrl: './form.errors.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormErrorsComponent {
  @Input() public errors: any;
  // Fired when the user follows a link out of the error list, so a host modal
  // can close itself before the route changes underneath it.
  @Output() public navigated: EventEmitter<void> = new EventEmitter<void>();

  // Query params for the Recycle Bin link on a deactivated-candidate error, or
  // null when the error is not one. The bin searches by name or email, so the
  // search box is prefilled with the email (falling back to the name).
  public recycleBinLink(error: IAPIErrorObject): IRecycleBinLink | null {
    const payload = error?.data?.deactivated ? error.data : error?.deactivated ? error : null;

    if (!payload) {
      return null;
    }

    const query = payload.candidate_email || payload.candidate_name;

    return query ? { query } : {};
  }
}
